<template lang="">
  <div class="div1">
    <ToastPrime />
    <DialogPrime
      header="EEXI Calc Logger"
      v-model:visible="displayLogger"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '75vw' }"
    >
      <template #footer>
        <ListBox :options="items" :virtualScrollerOptions="{ itemSize: 31 }" listStyle="height:400px" />
      </template>
    </DialogPrime>
    <div class="table-display">
      <div class="cell-display div2">
        <div class="card">
          <div class="formgrid grid">
            <div class="field col-12 md:col-4 text-left">
              <label for="firstname6">{{ $t("shipName") }} (*)</label>
              <input
                id="firstname6"
                v-model="ship.name"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6">{{ $t("imoNumber") }} (*)</label>
              <input
                id="lastname6"
                v-model="ship.imo"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <p for="state">{{ $t("shipType") }} (*)</p>
              <DropdownPrime
                id="state"
                v-model="shipTypeSelected"
                :options="shipTypes"
                optionLabel="name"
                class="field col-12 md:col-12"
              />
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <p for="iceClassElement">{{ $t("iceClass") }}</p>
              <DropdownPrime
                id="iceClassElement"
                v-model="iceClassTypeSelected"
                :options="iceClassTypeOptions"
                optionLabel="name"
                class="field col-12 md:col-12"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="firstname6">{{ $t("grossTonnage") }} - <strong>GT</strong> (t) (*)</label>
              <input
                id="firstname6"
                v-model="ship.gt"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t) (*)</label>
              <input
                id="lastname6"
                v-model="ship.dwt"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <label for="dateformat">{{ $t("dateKeelLaid") }}</label>
              <CalendarPrime
                id="dateformat"
                @input="formatDate()"
                @date-select="formatDate()"
                v-model="firstdate"
                dateFormat="yy/mm/dd"
                class="surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="dateformat">{{ $t("dateSigning") }}</label>
              <CalendarPrime
                id="dateformat"
                @input="formatDate()"
                @date-select="formatDate()"
                v-model="seconddate"
                dateFormat="yy/mm/dd"
                class="surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="dateformat">{{ $t("dataDelivery") }}</label>
              <CalendarPrime
                id="dateformat"
                @input="formatDate()"
                @date-select="formatDate()"
                v-model="thirddate"
                dateFormat="yy/mm/dd"
                class="surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <label for="firstname6"
                >{{ $t("displacementVolume") }} - <strong>V<sub>d</sub></strong> (m&sup3;)</label
              >
              <input
                v-model="ship.displacementVolume"
                type="numeric"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="firstname6" class="right">{{ $t("lengthOverall") }} - <strong>LOA</strong> (m)</label>
              <input
                id="firstname6"
                v-model="ship.loa"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6">{{ $t("lengthbtwPerpendicular") }} - <strong>LPP</strong> (m)</label>
              <input
                id="lastname6"
                v-model="ship.lpp"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <label for="firstname6" class="right"
                >{{ $t("summerLoad") }} - <strong>d<sub>s</sub></strong> (m)</label
              >
              <input
                id="firstname6"
                v-model="ship.ds"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("breadth") }} - <strong>B<sub>s</sub></strong> (m)</label
              >
              <input
                id="lastname6"
                v-model="ship.bs"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-4 text-left">
              <label for="firstname6" class="right"
                >{{ $t("shipSpeed") }} - <strong>V<sub>ref</sub></strong> (kn)</label
              >
              <input
                id="firstname6"
                v-model="ship.manualVref"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>

            <div
              v-if="
                shipTypeSelected.name == 'Tanker' ||
                shipTypeSelected.name == 'Bulk carrier' ||
                shipTypeSelected.name == 'LNG Carrier'
              "
              class="field col-12 md:col-4 text-left p-2"
            >
              <label for="lastname6"
                >{{ $t("vTanks") }} - <strong>V<sub>tanks</sub></strong> (m&sup3;)</label
              >
              <input
                id="lastname6"
                v-model="ship.vTanks"
                type="text"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="!EEDI" class="field col-12 md:col-12 p-2"></div>
            <div v-if="!EEDI" class="field col-12 md:col-12 text-left">
              <label for="powerLimitElement">{{ $t("powerLimitElement") }}:</label>
              <SelectButton
                id="powerLimitElement"
                name="speedPowerTests"
                v-model="speedPowerTests"
                :options="options"
              />
            </div>
            <div v-if="speedPowerTests == 'Yes'" class="field col-12 md:col-4 text-left p-2">
              <label for="lastname6">{{ $t("vsService") }}</label>
              <input
                v-model="ship.vsService"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="speedPowerTests == 'Yes'" class="field col-12 md:col-4 text-left p-2">
              <label for="lastname6">{{ $t("dwtsService") }}</label>
              <input
                v-model="ship.dwtsService"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="speedPowerTests == 'Yes'" class="field col-12 md:col-4 text-left p-2">
              <label for="lastname6"> {{ $t("psService") }}</label>
              <input
                v-model="ship.psService"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6" class="p-1">{{ $t("structuralEnhancement") }}</label>
              <SelectButton
                id="structuralEnhancement"
                name="structuralEnhancement"
                v-model="structuralEnhancement"
                :options="options"
              />
            </div>
            <div
              v-if="structuralEnhancement == 'No' || structuralEnhancement == null"
              class="field col-12 md:col-8 text-left"
            >
              <div></div>
            </div>
            <div v-if="structuralEnhancement == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6">
                {{ $t("lwtReferenceDesign") }} - <strong>LWT<sub>referencedesign</sub></strong> (t)</label>
              <input
                v-model="ship.lwtReferenceDesign"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="structuralEnhancement == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("lwtEnhancedDesign") }} - <strong>LWT<sub>enhanceddesign</sub></strong> (t)</label
              >
              <input
                v-model="ship.lwtEnhancedDesign"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="structuralEnhancement == 'Yes'" class="field col-12 md:col-4 text-left">
              <div></div>
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6" class="p-1">{{ $t("has_csr") }}</label>
              <SelectButton id="structuralRules" name="structuralRules" v-model="has_csr" :options="options" />
            </div>
            <div v-if="has_csr == 'No' || has_csr == null" class="field col-12 md:col-8 text-left">
              <div></div>
            </div>

            <div v-if="has_csr == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("deadweightCSR") }} - <strong>DWT<sub>CSR</sub></strong> (t)</label
              >
              <input
                v-model="ship.dwtCsr"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="has_csr == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("lightweightCSR") }} - <strong>LWT<sub>CSR</sub></strong> (t)
              </label>
              <input
                v-model="ship.lwtCsr"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>

            <div v-if="has_csr == 'Yes'" class="field col-12 md:col-4 text-left">
              <div></div>
            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4 text-left">
              <label for="lastname6" class="p-1">{{ $t("has_sideLoaders") }}</label>
              <SelectButton id="sideLoaders" name="sideLoaders" v-model="has_sideloaders" :options="options" />
            </div>
            <div v-if="has_sideloaders == 'No' || has_sideloaders == null" class="field col-12 md:col-8 text-left">
              <div></div>
            </div>
            <div v-if="has_sideloaders == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("capacityNoSideloaders") }} - <strong>Capacity<sub>No sideloaders</sub></strong> (t)</label
              >
              <input
                v-model="ship.capacityNoSideloaders"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="has_sideloaders == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("capacitySideloaders") }} <strong>Capacity<sub>Sideloaders</sub></strong> (t)</label
              >
              <input
                v-model="ship.capacitySideloaders"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="has_sideloaders == 'Yes'" class="field col-12 md:col-4 text-left">
              <div></div>
            </div>
            <div class="field col-12 md:col-12 p-2"></div>

            <div v-if="shipTypeSelected.name == 'Ro-Pax vessels'" class="field col-12 md:col-12 p-2 text-left">
              <label>{{ $t("highSpeedCruise") }}</label>
              <SelectButton v-model="highSpeedCruise" :options="options" />
            </div>

            <div class="field col-12 md:col-4 text-left p-2">
              <label for="lastname6">{{ $t("has_roro_ramps") }}</label>
              <SelectButton id="roro" name="roro" v-model="has_roro_ramps" :options="options" />
            </div>
            <div v-if="has_roro_ramps == 'No' || has_roro_ramps == null" class="field col-12 md:col-8 text-left">
              <div></div>
            </div>
            <div v-if="has_roro_ramps == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("capacityNoRORORamp") }} - <strong>Capacity<sub>No RO-ROramp</sub></strong> (t)</label
              >
              <input
                v-model="ship.capacityNoRORORamp"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="has_roro_ramps == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6"
                >{{ $t("capacityRORORamp") }} - <strong>Capacity<sub>RO-ROramp</sub></strong> (t)</label
              >
              <input
                v-model="ship.capacityRORORamp"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-if="has_roro_ramps == 'Yes'" class="field col-12 md:col-2 text-left">
              <div></div>
            </div>
            <div class="field col-12 md:col-12 p-3"></div>

            <div v-if="shipTypeSelected.name == 'Tanker'" class="field col-12 md:col-2 text-left">
              <label for="lastname6">{{ $t("isChemicalTanker") }}</label>
              <SelectButton id="ChemicalTank" name="ChemicalTank" v-model="ship.isChemicalTanker" :options="options" />
            </div>
            <div v-if="shipTypeSelected.name == 'Tanker'" class="field col-12 md:col-12 p-2"></div>

            <div
              v-if="
                shipTypeSelected.name == 'Tanker' ||
                shipTypeSelected.name == 'General cargo vessels' ||
                (shipTypeSelected.name == 'Bulk carrier' && ship.ice != 'None')
              "
              class="field col-12 md:col-4 text-left"
            >
              <label for="lastname6">{{ $t("capacityCorrection") }}</label>
              <SelectButton
                id="CapacityCorrection"
                name="CapacityCorrection"
                v-model="capacityCorrection"
                :options="options"
              />
            </div>
            <div v-if="capacityCorrection == 'Yes'" class="field col-12 md:col-4 text-left">
              <label for="lastname6">{{ $t("cb") }} - <strong>Cb</strong></label>
              <input
                v-model="ship.cb"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              />
            </div>
            <div v-else class="field col-12 md:col-6 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>

            <div v-if="shipTypeSelected.name == 'General cargo vessels'" class="grid col-12 md:col-12">
              <div class="col-12 md:col-4">
                <ButtonPrime class="crane_button" @click="addCrane()">{{ $t("addCrane") }}</ButtonPrime>
                <ButtonPrime class="crane_button" @click="removeCrane()">{{ $t("removeCrane") }}</ButtonPrime>
              </div>
              <div class="col-12 md:col-8">
                <DataTablePrime
                  :value="cranes"
                  editMode="cell"
                  class="editable-cells-table"
                  responsiveLayout="scroll"
                  @cell-edit-complete="onCraneEditComplete"
                >
                  <ColumnPrime
                    v-for="col of cranesTableColumns"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    style="width: 25%"
                  >
                    <template #editor="{ data, field }">
                      <InputTextPrime v-model="data[field]" autofocus />
                    </template>
                  </ColumnPrime>
                </DataTablePrime>
              </div>
            </div>
            <div class="field col-12 md:col-12 text-left">
              <p>(*) {{ $t("requiredFields") }}</p>
            </div>
            <div class="field col-12 md:col-12 text-left">
              <div id="spacer"></div>
            </div>
            <div class="final_elements field col-12 md:col-12 grid">
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("requiredEEXI") }} (gCO&#8322;/t·nm)</label>
                <input
                  disabled="true"
                  id="lastname6"
                  v-model="ship.requiredEEXI"
                  type="text"
                  class="text-base text-color surface-overlay p-3 border-3 border-solid border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
              <div id="btn" class="field col-12 md:col-2">
                <ButtonPrime id="add-button" @click="calcEEXI()">{{ $t("calcRequiredEEXI") }}</ButtonPrime>
              </div>
              <div id="btn" class="field col-12 md:col-2">
                <ButtonPrime v-if="mustBeShowInfo()" @click="showInfo()">{{ $t("showInfo") }}</ButtonPrime>
              </div>
              <div id="btn" class="field col-12 md:col-2">
                <span></span>
              </div>
              <div id="btn" class="field col-12 md:col-2">
                <ButtonPrime @click="save()" id="add-button">{{ $t("save") }}</ButtonPrime>
              </div>
              <div id="btn" class="field col-12 md:col-2">
                <ButtonPrime @click="cancel()" id="add-button">{{ $t("cancel") }}</ButtonPrime>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
import router from "@/router/index";
import ShipService from "@/services/ShipService";
import ShipTypeService from "@/services/ShipTypeService";
import { ToastSeverity } from "primevue/api";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import ParametricTableService from "@/services/ParametricTableService";
import utils from "@/utils/configuration/config.js";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      ship: store.getters.currentShip,
      name: store.getters.currentShip.name,
      imo: store.getters.currentShip.imo,
      displacementVolume: store.getters.currentShip.displacementVolume,
      loa: store.getters.currentShip.loa,
      lpp: store.getters.currentShip.lpp,
      ds: store.getters.currentShip.ds,
      gt: store.getters.currentShip.gt,
      dwt: store.getters.currentShip.dwt,
      bs: store.getters.currentShip.bs,
      manualVref: store.getters.currentShip.manualVref,
      vTanks: store.getters.currentShip.vTanks,
      vsService: store.getters.currentShip.vsService,
      dwtsService: store.getters.currentShip.dwtsService,
      psService: store.getters.currentShip.psService,
      lwtReferenceDesign: store.getters.currentShip.lwtReferenceDesign,
      lwtEnhancedDesign: store.getters.currentShip.lwtEnhancedDesign,
      dwtCsr: store.getters.currentShip.dwtCsr,
      lwtCsr: store.getters.currentShip.lwtCsr,
      capacityNoSideloaders: store.getters.currentShip.capacityNoSideloaders,
      capacitySideloaders: store.getters.currentShip.capacitySideloaders,
      capacityNoRORORamp: store.getters.currentShip.capacityNoRORORamp,
      capacityRORORamp: store.getters.currentShip.capacityRORORamp,
      cb: store.getters.currentShip.cb,
      cranes: store.getters.currentShip.cranes ? store.getters.currentShip.cranes : [],
      capacityCorrection: store.getters.currentShip.capacityCorrection ? "Yes" : "No",
      structuralEnhancement: store.getters.currentShip.structuralEnhancement ? "Yes" : "No",
      has_csr: store.getters.currentShip.has_csr ? "Yes" : "No",
      has_sideloaders: store.getters.currentShip.has_sideloaders ? "Yes" : "No",
      has_roro_ramps: store.getters.currentShip.has_roro_ramps ? "Yes" : "No",
      speedPowerTests: store.getters.currentShip.speedPowerTests ? "Yes" : "No",
      highSpeedCruise: store.getters.currentShip.highSpeedCruise ? "Yes" : "No",

      items: [],
      displayLogger: false,
      EEDI: false,
      options: ["Yes", "No"],
      shipTypes: [],
      shipTypeSelected: { id: "", name: "" },
      iceClassTypeOptions: [],
      iceClassTypeSelected: { id: "", name: "" },
      firstdate: null,
      seconddate: null,
      thirddate: null,
      showMessage: false,
      submitted: false,

      cranesTableColumns: [
        { field: "swl", header: "swl" },
        { field: "reach", header: "reach" },
      ],
    };
  },
  validations() {
    return {
      imo: { required }, // Matches this.firstName
      name: { required }, // Matches this.lastName
      shipType: { required },
      displacementVolume: { required },
      dwt: { required },
      gt: { required },
      loa: { required },
      lpp: { required },
      ds: { required },
      bs: { required },
      manualVref: { required },
      vTanks: { required },
      vsService: { required },
      dwtsService: { required },
      psService: { required },
      lwtReferenceDesign: { required },
      lwtEnhancedDesign: { required },
      dwtCsr: { required },
      lwtCsr: { required },
      capacityNoSideloaders: { required },
      capacitySideloaders: { required },
      capacityNoRORORamp: { required },
      capacityRORORamp: { required },
      cb: { required },
      cranes: { required },
      iceClassTypeSelected: { required },
    };
  },
  components: {},
  created() {
    this.shipService = ShipService.getInstance();
    this.shipTypeService = ShipTypeService.getInstance();
    this.shipTypeService.getTypes(this.shipTypes);

    if (this.ship && this.ship.shipType) {
      const objForWindow = {
        id: this.ship.shipType.id,
        name: this.ship.shipType.name,
      };
      this.shipTypeSelected = objForWindow;
    }

    this.EEDI = this.shipService.calcIsEEDIUsingDates(this.ship);
    //console.log("EEDI", this.EEDI);

    // Formateo de las fechas para el componente
    this.firstdate = this.getDateToComponent(this.ship.keelLaidDownDate);
    this.seconddate = this.getDateToComponent(this.ship.contractSignInDate);
    this.thirddate = this.getDateToComponent(this.ship.shipDeliveredDate);

    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);

    this.iceClassTypeSelected = this.ship.iceClassType;
    //console.log("Estableciendo el tipo de hielo", this.ship.iceClassType, "en el selector");
  },
  mounted() {
    const parametricTables = ParametricTableService.getInstance().getParametricTable(
      utils.config.firebaseConfig.parametricVersion
    );
    //console.log("parametricTables", parametricTables);
    this.iceClassTypeOptions = parametricTables.iceClassType;
    //console.log("Cargados los tipos de hielo");
  },
  methods: {
    onCraneEditComplete(event) {
      let { data, newValue, field } = event;
      data[field] = newValue;
    },
    addCrane() {
      const crane = {
        swl: 0,
        reach: 0,
      };
      this.cranes.push(crane);
    },
    removeCrane() {
      this.cranes.pop();
    },
    handleSubmit(isFormValid) {
      this.submitted = true;

      if (!isFormValid) {
        return;
      }

      this.toggleDialog();
    },
    toggleDialog() {
      this.showMessage = !this.showMessage;

      if (!this.showMessage) {
        this.resetForm();
      }
    },
    resetForm() {
      this.name = "";
    },
    getDateToComponent(dateFromFirebase) {
      return dateFromFirebase;
    },
    calcEEXI() {
      this.handleSubmit();
      this.applyChangesToShip();
      const successfulCalc = this.shipService.calcRequiredEEXI(this.ship);
      if (successfulCalc) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: "Calculado EEXI Requerido con éxito",
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error en cálculo del EEXI Requerido. Revise Log.",
        });
      }
      //console.log(this.shipTypeSelected);
      //console.log(this.ship);
    },
    mustBeShowInfo() {
      return this && this.ship && this.ship.logElement && this.ship.logElement.length > 0;
    },
    showInfo() {
      this.items = this.ship.logElement;
      this.displayLogger = true;
    },
    formatDate() {
      this.applyChangesToShip();
      this.EEDI = this.shipService.calcIsEEDIUsingDates(this.ship);
      //console.log("Han cambiado las fechas. IsEEDI = ", this.EEDI);

      this.$toast.add({
        severity: ToastSeverity.INFO,
        closable: false,
        summary: "Cambio de fechas. " + (this.EEDI ? " ¡¡ IS EEDI !!" : " NO EEDI"),
        life: 1000,
      });
    },
    applyChangesToShip() {
      this.ship.isNEOBUQ = false;
      this.ship.cranes = this.cranes;
      this.ship.capacityCorrection = this.capacityCorrection === "Yes";
      this.ship.has_csr = this.has_csr === "Yes";
      this.ship.structuralEnhancement = this.structuralEnhancement === "Yes";
      this.ship.has_sideloaders = this.has_sideloaders === "Yes";
      this.ship.has_roro_ramps = this.has_roro_ramps === "Yes";
      this.ship.speedPowerTests = this.speedPowerTests === "Yes";
      this.ship.keelLaidDownDate = this.firstdate;
      this.ship.contractSignInDate = this.seconddate;
      this.ship.shipDeliveredDate = this.thirddate;

      //console.log("Vamos a ponerle el tipo y el ice class ", this.shipTypeSelected, "al buque", this.ship);
      ShipTypeService.AddShipTypeToShip(this.shipTypeSelected.id, this.ship);
      this.ship.iceClassType = this.iceClassTypeSelected;
      //console.log("Después de ponérselo el buque queda así", this.ship);
    },
    save() {
      this.applyChangesToShip();
      //console.log("FormEditShip-save", this.ship);
      const errorsInSave = this.shipService.saveShip(store.getters.currentShip);

      if (errorsInSave === "") {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: "Buque salvado correctamente",
          life: 1000,
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error salvando el buque:" + errorsInSave,
          life: 5000,
        });
      }
    },
    cancel() {
      //console.log("FormEditShip-cancel", this.ship);
      this.shipService.selectedShip({});
      router.push({ name: "home" });
    },
  },
  computed: {
    configuration_edit() {
      return store.getters.stateFormConfigEdit;
    },
    shipNameComputed() {
      return store.getters.currentShip["name"];
    },
    configuration() {
      return store.getters.currentConfiguration;
    },
  },
};
</script>
<style scoped>
.div1 {
  margin-top: 10px !important;
}

.div2 {
  padding: 2%;
}

.div4 {
  border-radius: 10px;
  border: 1px solid;
  padding: 2%;
  margin-bottom: 1%;
}

.final_elements {
  margin-top: 20px !important;
  padding: 20px 0px 0px 0px !important;
  margin-bottom: 80px !important;
  border: 2px solid black;
}

.crane_button {
  margin: 20px !important;
}

#btn {
  padding: 1.2%;
}
#inputField {
  width: 100%;
}
</style>
